var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXwg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#59438F",
    d: "M21 12.026s-.334-.733-1.127-1.196l-.099.549c.399.124.806.334 1.226.643zM4.714 6.938s.36.832.668 2.143l.42-1.135z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80478F",
    d: "m5.802 7.946l-.42 1.131a15 15 0 0 1 .386 3.729l.729-2.122c-.052-.411-.099-.848-.172-1.307l.467.446l.249-.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D42C78",
    d: "M7.337 11.34s.48 2.76-.669 5.374c0 0 .137-.051.394-.128l1.363-4.2a9 9 0 0 1-1.088-1.046m-.309-2.263l-.248.733l1.902 1.778l.249-.758zm-2.057 7.599s2.156-.172 1.513-6.005l-.729 2.126c-.043 1.243-.261 2.563-.78 3.879z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEB343",
    d: "m10.911 10.706l-.484.634s.163.188.433.463l.197-.935a2 2 0 0 1-.146-.162M11.43 9.2l.372-1.74l-2.832 3.407l-.039-.038l-.249.758l.288.262zm-3.438 6.283s.322-1.26.223-2.301l1.886 1.191s.09-.047.24-.163l.283-1.328c-.159.128-.322.261-.506.386c0 0-.728-.138-1.693-.883l-1.363 4.2a17.4 17.4 0 0 1 2.885-.605l.218-.998q-1.107.155-2.173.501"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#81BA5A",
    d: "m11.914 8.678l1.603 1.779l.214-.969l-1.92-2.027h-.013l-.368 1.74l.48-.523zm.947 4.89l.171-.81c-.158-.124-.342-.287-.557-.458c.275-.287.575-.622.87-.986v-.021l-.505-.622s-.335.446-.952 1.072q-.424-.423-.831-.862l-.197.93l.471.472c-.214.201-.459.403-.707.613l-.283 1.328c.3-.21.879-.655 1.607-1.38q.447.375.913.725m-2.696 1.406l-.218.995a21 21 0 0 1 2.434-.19l.214-.98c-.771 0-1.585.047-2.43.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5EA4D4",
    d: "M14.185 13.457s-.355-.077-1.148-.699l-.172.81c.48.343.986.656 1.47.845c0 0 .459-.72 1.213-1.479l.21-1.11a8.6 8.6 0 0 0-1.573 1.629zm.583-1.607l1.187-1.119l.21-1.131l-1.247 1.157l-1.187-1.269l-.214.969zm-2.177 2.961l-.214.986c.81-.017 1.671.009 2.588.107l.172-.921a19 19 0 0 0-2.546-.172"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80478F",
    d: "m18.171 10.483l-.249.921a3.2 3.2 0 0 1 1.843-.013l.099-.548a2.7 2.7 0 0 0-1.697-.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80478F",
    d: "M17.537 15.497s-.249-.077-.669-.188l-.223.844c.695.137 1.397.326 2.117.548c0 0-1.088-2.087-.84-5.314l-.72 2.666c.078.471.185.955.335 1.444"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D42C78",
    d: "M17.511 9.24s-.223.621-.356 1.641c-.398.215-.891.51-1.414.943l-.206 1.11c.42-.424.952-.857 1.543-1.183c-.039.774.004 1.55.129 2.315l.96-3.583c-.047 0-.086.013-.133.013c.186-1.224.54-2.417 1.05-3.545c0 0-1.672 1.517-2.893 2.649l-.214 1.131zm-2.374 5.743l-.172.921q.817.096 1.672.262l.223-.845a15 15 0 0 0-1.723-.338"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXwg);
export default __webpack_public_path__ + "static/media/xwg.a4df0de366669c401ba2a1504038234d.svg";
export { ForwardRef as ReactComponent };